import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    Box,
    Typography,
    Stack
} from "@mui/material";
import { Warning, Delete, Assessment as AssessmentIcon } from "@mui/icons-material";
import { useState } from "react";

interface DeleteResponsesDialogInterface {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onProceed: () => void;
}

export default function DeleteResponsesDialog({ 
    open, 
    setOpen, 
    onProceed 
}: DeleteResponsesDialogInterface) {
    const [loading, setLoading] = useState(false);

    const handleClose = () => setOpen(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            setOpen(false);
            onProceed();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-responses-dialog-title"
            aria-describedby="delete-responses-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle 
                id="delete-responses-dialog-title"
                sx={{ fontWeight: 'bold' }}
            >
                Delete Responses?
            </DialogTitle>

            <DialogContent>
                <DialogContentText 
                    id="delete-responses-dialog-description"
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                    }}
                >
                    Are you sure you want to delete these responses?
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    disabled={loading}
                    sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        borderColor: '#d1d5db',
                        color: '#6b7280',
                        '&:hover': {
                            borderColor: '#9ca3af',
                            backgroundColor: '#f9fafb'
                        }
                    }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={handleDelete}
                    variant="contained"
                    disabled={loading}
                    sx={{ 
                        backgroundColor: "#dc2626",
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        py: 1,
                        boxShadow: '0 4px 12px -2px rgba(220, 38, 38, 0.3)',
                        '&:hover': {
                            backgroundColor: "#b91c1c",
                            boxShadow: '0 8px 20px -4px rgba(220, 38, 38, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        '&:disabled': {
                            backgroundColor: "#fca5a5",
                            color: '#ffffff'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    {loading ? 'in progress...' : 'Proceed'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}